import { useEffect, useState } from "react";

const BLOCKER_SELECTOR = "[data-tour-blocker]";

const queryBlockers = (): Element[] => Array.from(document.querySelectorAll(BLOCKER_SELECTOR));

export const useTourBlocker = (): Element[] => {
  const [blockers, setBlockers] = useState<Element[]>(queryBlockers);

  useEffect(() => {
    let frame: number | null = null;
    const check = (): void => {
      setBlockers((previous) => {
        const next = queryBlockers();
        const same =
          next.length === previous.length && next.every((el, index) => el === previous[index]);
        return same ? previous : next;
      });
    };
    const observer = new MutationObserver(() => {
      if (frame === null) {
        frame = requestAnimationFrame(() => {
          frame = null;
          check();
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    check();
    return () => {
      observer.disconnect();
      if (frame !== null) {
        cancelAnimationFrame(frame);
      }
    };
  }, []);

  return blockers;
};

export default useTourBlocker;
